export default {
    wizardType: "STRIPE",

    getConnectionParams: (type, model) => ({
        useConnectionProfile: model.get("useConnectionProfile"),
        connectionProfileName: model.get("connectionProfileName"),
        AccountId: model.get("accountId"),
        APIKey: model.get("apiKey"),
        isConnectedAccount: model.get("connectedAccount"),
        AuthMode: model.get("authMode"),
        AccessToken: model.get("accessToken"),
        ClientID: model.get("clientId"),
        ClientSecret: model.get("clientSecret"),
        RefreshToken: model.get("refreshToken"),
    }),
};

